import img from '../../images/Nexus_6_piccolo_display_trasparent_list.png'
import { PALETTE } from '../../common/styles/palette'
export const styles = (theme: any) => {
    return {
        device: {
            height: '510px',
            width: '290px',
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'left',
            backgroundPositionY: 'top',
        },
        content: {
            margin: '8px',
            overflow: 'auto',
            //position: 'relative',
            top: '80px',
            left: '62px',
            height: '755px', // REALI height: 2560px,
            width: '380px', // REALI width: 1440px,
            transformOrigin: '0 0',
            transform: 'scale(0.5)',
            position: 'relative' as 'relative'
        },
        cropper: {
            marginBottom: '10px'
        },
        listPreviewImage: {
            margin: '5px',
            width: '60px',
            height: '60px',
            border: '1px solid black',
            backgroundColor: PALETTE.UI.Images.BackgroundColor
        },
        listItemContainer: {
            alignItems: 'center',
            padding: '5px'
        },
        spreadTypography: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
        },
        voteListItem: {
            paddingLeft: '0px',
            paddingRight: '0px',
            paddingTop: '4px',
            paddingBottom: '0px',
        },
        dateTypography: {
            fontSize: '10pt'
        },
        textContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        graphContainer: {
            display: 'block'
        },
        graphContainerFlex: {
            display: 'flex'
        },
        postInfo: {
            display: 'flex'
        },
        expansionPanelSummary: {
            padding: '0px',
        },
        exponsionPanelContent: {
            margin: '0px'
        },
        expansionButton: {
            height: '13px',
            marginRight: "0px !important"
        }, 
        voteExpansionIcon: {
            width: "20px",
            marginLeft: "10px"
        },
        voteYesButtonSelected: {
           backgroundColor: "green"
        },
        voteNoButtonSelected: {
           backgroundColor: "red"
        }
    }
}